export type ListRowBounds = {
  bottom: number;
  top: number;
};

/**
 * The tallest height up to `cap` that ends halfway through a row, so a list that scrolls shows a
 * half-cut row instead of stopping on a row edge and looking complete. Row bounds are measured from
 * the list's top edge. Returns `undefined` when every row fits under `cap`.
 */
export const getPeekingListMaxHeight = (rows: ListRowBounds[], cap: number): number | undefined => {
  const firstOverflowingIndex = rows.findIndex((row) => row.bottom > cap);

  if (firstOverflowingIndex === -1) {
    return undefined;
  }

  for (let index = firstOverflowingIndex; index >= 0; index -= 1) {
    const { bottom, top } = rows[index];
    const middle = (top + bottom) / 2;

    if (middle <= cap) {
      return middle;
    }
  }

  return undefined;
};
